import type { ExpenseEntry } from "web_myplann/Finances/Types/ExpenseEntry";
import { ClientFinancialPlanExpenseNameEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const getExpenseLabel = (expense: ExpenseEntry, t: TranslateFunction) =>
	expense.name === ClientFinancialPlanExpenseNameEnum.Total
		? t(Resources.Finances.Expenses.Types[expense.type].title)
		: t(Resources.Finances.Expenses.Names[expense.name]);
